import { useState } from 'react'
import { Alert, Box, Button, Stack, Typography } from '@mui/material'
import { CopyButton } from './CopyButton.jsx'
import { DAILY_LIMIT_STEP_STATE, sellerHubFacts } from './ebayDailyLimit.js'

// A message eBay refused for its daily limit on every route (2026-10-29): the
// text to send in Seller Hub with a copy button, the buyer's username and the
// order / item, and "Sent response through eBay Portal", which records it as sent (and closes the
// contact, as the send would have). onMarkSent() does the request; its error
// shows here.
export default function EbayDailyLimitNotice({ text, messageText, action = null, onMarkSent, disabled = false }) {
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState(null)
  const facts = sellerHubFacts(action)
  return (
    <Alert severity="warning" sx={{ mt: 0.5 }} data-testid="ebay-daily-limit-notice">
      <Typography variant="body2" fontWeight={700}>{DAILY_LIMIT_STEP_STATE}</Typography>
      <Typography variant="caption" display="block" sx={{ mb: 0.5 }}>{text}</Typography>
      {facts.length > 0 && (
        <Typography variant="caption" display="block" sx={{ mb: 0.5 }}>
          {facts.map(([k, v]) => `${k}: ${v}`).join(' · ')}
        </Typography>
      )}
      {messageText ? (
        <Stack direction="row" spacing={0.5} alignItems="flex-start" sx={{ mb: 0.5 }}>
          <Box component="pre" sx={{ m: 0, p: 0.75, flex: 1, minWidth: 0, maxHeight: 160, overflow: 'auto', whiteSpace: 'pre-wrap', wordBreak: 'break-word', fontFamily: 'inherit', fontSize: '0.75rem', bgcolor: 'background.paper', borderRadius: 1 }} data-testid="ebay-daily-limit-text">
            {messageText}
          </Box>
          <CopyButton value={messageText} ariaLabel="copy the message" />
        </Stack>
      ) : null}
      <Button size="small" variant="outlined" color="inherit" disabled={disabled || busy} data-testid="ebay-mark-sent"
        onClick={async () => {
          setBusy(true)
          setError(null)
          try { await onMarkSent?.() } catch (e) { setError(e?.message ?? 'Could not record it as sent') } finally { setBusy(false) }
        }}>
        Sent response through eBay Portal
      </Button>
      {error && <Typography variant="caption" color="error" display="block" sx={{ mt: 0.5 }}>{error}</Typography>}
    </Alert>
  )
}
